// extracted by mini-css-extract-plugin
export var askAiIcon = "_qz-9";
export var container = "_qz-0";
export var groupSeparator = "_qz-a";
export var highlight = "_qz-4";
export var resultIcon = "_qz-5";
export var resultItem = "_qz-7";
export var resultSubtitle = "_qz-3";
export var resultTitle = "_qz-2";
export var resultsList = "_qz-1";
export var searchGroup = "_qz-6";
export var selected = "_qz-8";